export default "__VITE_ASSET__Cc98bWXO__"